<template>
  <section class="bg-lifeboost-orange-100">
    <div class="max-w-screen-xl px-4 mx-auto 2xl:px-0">
    <svg width="0" height="0" class="hidden">
      <symbol xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20.099 19.261" id="star">
        <path id="star-curved"
          d="M20.046,7.774a1.067,1.067,0,0,0-.919-.734l-5.8-.527L11.033,1.145a1.069,1.069,0,0,0-1.966,0L6.774,6.514l-5.8.527A1.07,1.07,0,0,0,.364,8.91L4.75,12.755l-1.293,5.7a1.068,1.068,0,0,0,1.59,1.155l5-2.992,5,2.992a1.069,1.069,0,0,0,1.591-1.155l-1.293-5.7L19.735,8.91a1.07,1.07,0,0,0,.312-1.136Zm-9.9,8.783"
          transform="translate(0 -0.496)"></path>
      </symbol>
    </svg>
    <div class="bg-lifeboost-orange-100">
      <div class="relative w-full py-8 mx-auto overflow-hidden">
        <div class="flex flex-wrap items-start lg:items-center">

          <div class="w-full space-y-3.5 lg:space-y-4 pb-8 text-center mx-auto">
            <svg width="0" height="0" class="hidden">
              <symbol fill="orange" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="star1">
                <path
                  d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.536.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z">
                </path>
              </symbol>
            </svg>
            <p class="flex items-center justify-center mx-auto space-x-2 text-gray-300 !mt-0">
              <svg class="w-4 h-4">
                <use xlink:href="#star1"></use>
              </svg>
              <svg class="w-4 h-4">
                <use xlink:href="#star1"></use>
              </svg>
              <svg class="w-4 h-4">
                <use xlink:href="#star1"></use>
              </svg>
              <svg class="w-4 h-4">
                <use xlink:href="#star1"></use>
              </svg>
              <svg class="w-4 h-4">
                <use xlink:href="#star1"></use>
              </svg>

              <span class="text-white">{{ allReviewsCount }} {{ reviews }}</span>

            </p>
            <h1 class="font-extrabold text-white h1" v-html="title"></h1>
          </div>


        </div>

        <div
          class="flex flex-wrap justify-between lg:-mx-4 gap-y-6 xl:gap-y-8 2xl:gap-y-10">
          <div class="flex flex-col w-full px-2 md:w-1/2 lg:w-1/3 lg:px-2 xl:px-4" v-for="item in listItem">
            <div
              class="flex flex-col items-center h-full px-6 py-6 space-y-4 text-center bg-white rounded-lg shadow-xl xl:px-9">


              <div id="" class="aspect-auto">

                <nuxt-img class="object-cover w-40 h-40 rounded-full" width="157" height="157" loading="lazy"
                  format="webp" sizes="sm:157px  md:157vw lg:157vw xl:157px" :alt="item.imageAlt"
                  :src="item.image"></nuxt-img>


              </div>


              <div class="flex items-center justify-center space-x-3">
                <nuxt-img src="/assets/images/rating-yellow.png" alt="rating" class="sm-max:m-auto" width="100" height="16"
                format="webp" loading="lazy"></nuxt-img>
              </div>
              <div class="text-center space-y-3.5">
                <div class="font-semibold font-ww-medium h4" v-html="item?.title">

                </div>

                <p class="text-lg textp font-open-sans" v-html="item.description"></p>
                <p class="textp font-ww-medium" v-html="item.name"></p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
  </section>
</template>

<script setup>
const { data, error } = useFetch('https://lifebooxt.vercel.app/api/judgememedals')
const allReviewsCount = ref(0)

// Watch for changes in data or error
watchEffect(() => {
  if (!error.value && data.value) {
    allReviewsCount.value = data.value?.all_reviews_count || 0;
  }
});

const props = defineProps({
  bigMarginContainer: {
    type: Boolean,
    default: false
  },
  reviews: {
    type: String,
    default: 'Five-Star Reviews!',
  },
  title: {
    type: String,
    default: 'SEE WHAT CUSTOMERS <br> ARE SAYING…'
  },

  listItem: {
    type: Array,
    default: () => [
      {
        title: 'Best Mushroom Coffee Ever!',
        image: 'assets/images/img-reviews-2.jpg',
        imageAlt: 'Terry',
        description: 'Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!',
        name: '- Terry'
      },
      {
        title: 'Excellent coffee',
        image: '/assets/images/hollyt-img12.jpg',
        imageAlt: 'Holly T',
        description: 'This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay!',
        name: '- Holly T.'
      },
      {
        title: 'Best coffee, EVER!',
        image: 'assets/images/review-img-3.jpeg',
        imageAlt: 'MaryAnn Blanchard',
        description: 'I can’t say enough about this coffee. I’ve had my subscription now for over 2 years!<br><br> We love it!<br> Mahalo!!',
        name: '- MaryAnn Blanchard'
      },
      {
        title: 'Best new addiction so far!',
        image: 'assets/images/review-img-5.jpg',
        imageAlt: 'Teri Lewis',
        description: 'I’m in love with the smoothness and bold flavor of life boost.  Knowing it’s mold free gives me a piece of mind also!',
        name: '- Teri Lewis'
      },
      {
        title: 'Perfection',
        image: 'assets/images/review-img-6.jpg',
        imageAlt: 'Julie Vitale',
        description: 'I really love this flavor coffee! A+',
        name: '- Julie Vitale'
      },
      {
        title: 'Our new favorite',
        image: 'assets/images/review-img-7.jpeg',
        imageAlt: 'Natasha Smith',
        description: 'We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship.',
        name: '- Natasha Smith'
      },

    ],
  },


})

defineBuilderComponent({
  friendlyName: "Reviews4",
  inputs: [
    { name: 'bigMarginContainer', type: 'boolean', defaultValue: false },
    {
      name: "reviews",
      type: "string",
      defaultValue: "Five-Star Reviews!"
    },
    {
      name: "title",
      type: "string",
      defaultValue: "SEE WHAT CUSTOMERS <br> ARE SAYING…"
    },
    {
      name: "listItem",
      type: "list",
      defaultValue: [
      {
        title: 'Best Mushroom Coffee Ever!',
        image: 'assets/images/img-reviews-2.jpg',
        imageAlt: 'Terry',
        description: 'Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!',
        name: '- Terry'
      },
      {
        title: 'Excellent coffee',
        image: '/assets/images/hollyt-img12.jpg',
        imageAlt: 'Holly T',
        description: 'This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay!',
        name: '- Holly T.'
      },
      {
        title: 'Best coffee, EVER!',
        image: 'assets/images/review-img-3.jpeg',
        imageAlt: 'MaryAnn Blanchard',
        description: 'I can’t say enough about this coffee. I’ve had my subscription now for over 2 years!<br><br> We love it!<br> Mahalo!!',
        name: '- MaryAnn Blanchard'
      },
      {
        title: 'Best new addiction so far!',
        image: 'assets/images/review-img-5.jpg',
        imageAlt: 'Teri Lewis',
        description: 'I’m in love with the smoothness and bold flavor of life boost.  Knowing it’s mold free gives me a piece of mind also!',
        name: '- Teri Lewis'
      },
      {
        title: 'Perfection',
        image: 'assets/images/review-img-6.jpg',
        imageAlt: 'Julie Vitale',
        description: 'I really love this flavor coffee! A+',
        name: '- Julie Vitale'
      },
      {
        title: 'Our new favorite',
        image: 'assets/images/review-img-7.jpeg',
        imageAlt: 'Natasha Smith',
        description: 'We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship.',
        name: '- Natasha Smith'
      },

      ],
      subFields: [
        {
          name: "image",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png"
          ],
          required: true
        },
        {
          name: "imageAlt",
          type: "string"
        },
        {
          name: "title",
          type: "string"
        },
        {
          name: "description",
          type: "string"
        },
        {
          name: "name",
          type: "string"
        }
      ]
    }
  ]
});
</script>